package com.havn.app.ui.theme

import kotlinx.browser.window

private const val HavnThemeKey = "havn.theme"

actual fun loadStoredHavnThemeType(): HavnThemeType =
    HavnThemeType.fromStorageKey(window.localStorage.getItem(HavnThemeKey))

actual fun storeHavnThemeType(type: HavnThemeType) {
    window.localStorage.setItem(HavnThemeKey, type.storageKey)
}
